import React from 'react'
import { Dropdown, Input, Select, Space, Switch } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useEffect } from 'react';


const CustomDropDownAutoComplete = ({ items, selectedName = 'Kindly Select Value', apiCall, setSelectedName, width = '250px', id }) => {

    useEffect(() => {

        let existingFilters = JSON.parse(localStorage.getItem('TicketAlert_filter'))
        if (existingFilters)
            setSelectedName(existingFilters[id])

    }, [])

    const onClick = (e) => {
        let index = items?.findIndex(item => e.key == item.key)
        setSelectedName(items[index])
    }


    const onChange = (value, item) => {
        setSelectedName(value)
        // let existingFilters = JSON.parse(localStorage.getItem('TicketAlert_filter'))
        // if (existingFilters)
        //     localStorage.setItem('TicketAlert_filter', JSON.stringify({ ...existingFilters, [id]: value }))
        // else
        //     localStorage.setItem('TicketAlert_filter', JSON.stringify({ [id]: value }))
    };
    const onSearch = (value) => {
         
    };

    // Filter `option.label` match the user type `input`
    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
    return (

        <Select style={{ width: width, }}
            showSearch
            value={selectedName}
            placeholder={`${selectedName}`}
            optionFilterProp="children"
            onChange={onChange}
            onSearch={onSearch}
            filterOption={filterOption}
            options={items}
        />
    )
}

export default CustomDropDownAutoComplete

